export default __webpack_public_path__ + "static/media/JP3-2.9a0169b7.jpg";